const ROUTES = {
	CONNECT: "/connect",
	ADMIN_OVERVIEW: "/admin",
	REQUEST_CNFG: "/request",
	FORM_CONFIGURATION: "/request-configuration",
	PTKM: "/ptkm",
	PTKM_CONFIGURATION: "/ptkm-configuration",
	PTKM_CALENDAR: "/ptkm-calendar",
	USER: "/",
	DEV_ICONS: "/dev-icons",
	DEV_LOGIN: "/dev-login",
	UNAUTHORIZED_ACCESS: "/unauthorized",
} as const

export default ROUTES
